import { ArrowLeftOutlined, CaretDownOutlined, CheckOutlined, EditOutlined, EnvironmentOutlined, ExclamationCircleFilled, GithubOutlined, GlobalOutlined, HighlightOutlined, IdcardOutlined, InstagramOutlined, MailOutlined, RightOutlined, SettingOutlined, XOutlined } from '@ant-design/icons'
import { Avatar, Button, Divider, Flex, Input, message, Modal, Popover, Space, Switch, Tag, Typography, Upload } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { getDeviceInfo, getUserIP, shortAddress } from '../utils/location'
import { clearUser, setUser } from '../redux/slice/user'
import { signOut } from "firebase/auth";
import { auth, db_fire } from '../firebase'
import { loginWithGoogle } from '../firebase/googleLogin'
import { useEffect, useState } from 'react'
import Loading from '../components/Loading'
import { addDoc, collection, doc, getDoc, getDocs, query, serverTimestamp, updateDoc, where } from 'firebase/firestore'
import axios from '../axios'
import moment from 'moment'
import TextArea from 'antd/es/input/TextArea'
const { confirm } = Modal;

const Profile = () => {
    const { userDetails } = useSelector((state) => state.user);
    const { location, orderType } = useSelector(state => state.local)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const handleLogout = async _ => {
        await signOut(auth);
        localStorage.clear();
        sessionStorage.clear();
        await dispatch(clearUser())
        navigate("/", { replace: true })
    }
    const showLogoutConfirm = () => {
        confirm({
            title: 'Are you sure want to logout?',
            icon: <ExclamationCircleFilled />,
            // content: 'Some descriptions',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleLogout()
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handleUpdateName = async e => {
        if (!e) { return message.warning("Name is required.") }
        await updateDoc(doc(db_fire, "users", userDetails._id), { name: e });
        dispatch(setUser({ name: e }))
        message.success("User name updated.");
    }


    const handleGoogleLogin = async () => {
        try {
            setLoading(true)
            const user = await loginWithGoogle();
            var userData = {
                name: user.displayName,
                email: user.email,
                phone: user.phoneNumber,
                photo: user.photoURL,
            }

            const usersRef = collection(db_fire, "users");

            // 🔍 Find user by email
            const q = query(usersRef, where("email", "==", userData.email));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                return message.error("Email already exist.")
            }

            await updateDoc(doc(db_fire, "users", userDetails._id), userData);

            dispatch(setUser(userData));
            message.success("Profile updated.");

            var user_device = getDeviceInfo() || "Unknown";
            var user_ip = await getUserIP() || "Unknown";
            if (userData?.email) {
                await axios.post("/send-welcome-mail", {
                    to: userData?.email,
                    name: userData?.name,
                    device: user_device,
                    location: location.address,
                    ip: user_ip,
                    time: moment(Date.now()).format("llll")
                });
            }

        } catch (err) {
            console.error("Google Login Error 👉", err);
            message.error(err.code || err.message);
        } finally {
            setLoading(false)
        }
    };
    const [nameopen, setNameOpen] = useState(false);
    const handleNameOpenChange = newOpen => {
        setNameOpen(newOpen);
    };

    const [subject, setsubject] = useState("");
    const [remark, setremark] = useState("");
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const handleOpenChange = newOpen => {
        setOpen(newOpen);
    };

    const handleChangeMode = async (s) => {
        try {
            // 🔒 validation before switching to Delivery
            if (s) {
                if (!userDetails.phone || !userDetails.email) {
                    return message.warning("Complete your profile to enable Delivery mode.");
                }
            }

            const role = s ? "Delivery" : "Customer";

            // 🔥 UPDATE FIRESTORE USER ROLE
            await updateDoc(
                doc(db_fire, "users", userDetails._id),
                {
                    role,
                    updatedAt: serverTimestamp(),
                }
            );

            message.success(`Switched to ${role} mode`);
        } catch (err) {
            console.error(err);
            message.error("Failed to change mode. Try again.");
        }
    };

    return (
        <>
            {loading && <Loading />} 

            <div style={{ display: "flex", gap: 10, background: "white", padding: "15px", borderRadius: "10px", flexDirection: "column" }}>

                <Flex gap={10}>

                    <Avatar src={userDetails.photo} size={50}>
                        {userDetails.name.split(/\s+/)
                            .filter(Boolean)
                            .map(w => w[0])
                            .join("")
                            .toUpperCase()}
                    </Avatar>

                    <Flex flex={1} justify='space-around' vertical >
                        <Typography.Text>  {userDetails.name}
                            <Popover
                                content={<>
                                    <Input
                                        autoFocus
                                        defaultValue={userDetails.name}
                                        onKeyUp={async e => {
                                            var name = e.target.value
                                            if (e.key === "Enter") {
                                                handleUpdateName(name)
                                                handleNameOpenChange()
                                            }
                                        }} />
                                </>}
                                trigger="click"
                                placement='top'
                                open={nameopen}
                                onOpenChange={handleNameOpenChange}
                            >
                                <Button size='small' type='link' icon={<EditOutlined />}></Button>
                            </Popover>
                        </Typography.Text>

                        {userDetails.phone
                            ? <Typography.Text italic>+91 {userDetails.phone}</Typography.Text>
                            : <Typography.Text>
                                <Popover
                                    content={<>
                                        <Input
                                            type='number'
                                            onKeyUp={async e => {
                                                var phone = e.target.value
                                                if (e.key === "Enter") {
                                                    if (!phone) { return message.warning("Phone number required.") }
                                                    if (phone.length !== 10) { return message.warning("Invalid Phone number.") }

                                                    await updateDoc(doc(db_fire, "users", userDetails._id), { phone });
                                                    dispatch(setUser({ phone }))
                                                    message.success("User phone updated.");
                                                }
                                            }}
                                            prefix="+91 "
                                            maxLength={10} />
                                    </>}
                                    trigger="click"
                                    placement='right'
                                    open={open}
                                    onOpenChange={handleOpenChange}
                                >
                                    <Button size='small' type='link' icon={<EditOutlined />}>Add Phone</Button>
                                </Popover>
                            </Typography.Text>
                        }

                    </Flex>

                    {userDetails.role === "Delivery" &&
                        <Flex vertical>
                            {userDetails.verified
                                ? <Tag color="green">Verified</Tag>
                                : <Tag color="red">Unverified</Tag>}
                        </Flex>}
                </Flex>

                {userDetails.email
                    ? <Typography.Text>&ensp;<MailOutlined /> &nbsp;  {userDetails.email}</Typography.Text>
                    : <Typography.Text> &ensp; Add Email  <Button size='small' onClick={handleGoogleLogin} type='link' icon={<EditOutlined />}></Button></Typography.Text>
                } 
                {userDetails?.aadhar && userDetails.role === "Delivery" && <Typography.Text> &nbsp; <IdcardOutlined /> &nbsp; <font color={userDetails.verified ? "green" : ""}>Government Id Uploaded</font> </Typography.Text> } 
                {userDetails?.remark && userDetails.role === "Delivery" && <Typography.Text italic style={{color:"red"}}> &ensp;  {userDetails.remark}</Typography.Text> } 
                {userDetails.role === "Delivery"
                    &&
                    <> {
                        !userDetails?.aadhar && 
                        <Upload
                            accept="image/*,.pdf"
                            maxCount={1}
                            beforeUpload={async (file) => {
                                const data = new FormData();
                                data.append('file', file);

                                try {
                                    var res = await axios.post('/upload', data);
                                    var aadhar = res.data?.url;

                                    await updateDoc(doc(db_fire, "users", userDetails._id), { aadhar,remark:"Aadhar card under review." });
                                    dispatch(setUser({ aadhar }))
                                    message.success("User aadhar updated.");

                                } catch (err) {
                                    message.error('Upload failed');
                                }

                                return false; // ❗ prevents auto upload
                            }}
                        >
                            <Button size="small" type="link" icon={<IdcardOutlined />}>
                                Upload Aadhar
                            </Button>
                        </Upload>



                        // <Typography.Text>
                        //         <Popover
                        //             content={<>
                        //                 <Input
                        //                     type='number'
                        //                     onKeyUp={async e => {
                        //                         var aadhar = e.target.value
                        //                         if (e.key === "Enter") {
                        //                             if (!aadhar) { return message.warning("Aadhar number required.") }
                        //                             if (aadhar.length !== 12) { return message.warning("Invalid aadhar number.") }

                        //                             await updateDoc(doc(db_fire, "users", userDetails._id), { aadhar });
                        //                             dispatch(setUser({ aadhar }))
                        //                             message.success("User aadhar updated.");
                        //                         }
                        //                     }}
                        //                     maxLength={12} />
                        //             </>}
                        //             trigger="click"
                        //             placement='right'
                        //             open={open}
                        //             onOpenChange={handleOpenChange}
                        //         >
                        //             <Button size='small' type='link' icon={<IdcardOutlined />}>Add Aadhar</Button>
                        //         </Popover>
                        //     </Typography.Text>
                    }
                    </>
                }

            </div>

            <Flex justify='end' align='center' gap={10} style={{ marginTop: "10px", marginRight: "5px" }}>
                <Typography.Text strong>{userDetails?.role} Mode</Typography.Text>
                <Switch
                    checked={userDetails?.role === "Delivery"}
                    onChange={handleChangeMode} size='small' />
            </Flex>


            <div style={{ background: "white", borderRadius: "10px", padding: "15px", margin: "10px 0" }}>
                {/* this is menu bars  */}
                {userDetails?.role === "Customer" && <>
                    <Typography.Title level={5} onClick={() => navigate("/cart")} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Cart<RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
                    <Typography.Title level={5} onClick={() => navigate("/reward")} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Rewards<RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
                    <Typography.Title level={5} onClick={() => navigate("/coupon")} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Coupons<RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
                </>}
                <Typography.Title level={5} onClick={() => navigate("/order")} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Orders<RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
                <Typography.Title level={5} onClick={() => setContactModalOpen(true)} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Contact Us <RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
                <Divider />
                <Typography.Title level={5} onClick={showLogoutConfirm} style={{ width: "100%", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>Log Out <RightOutlined style={{ fontSize: "12px" }} /> </Typography.Title>
            </div>
            <Flex justify='end' align='center' gap={7} style={{ marginRight: "10px", fontSize: "14px" }}>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <font color="gray">•</font>
                <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            </Flex>
            <br />
            <Modal onOk={async _ => {
                setLoading(true)
                var userData = {
                    userId: userDetails._id,
                    subject,
                    remark,
                    createdAt: serverTimestamp()
                }
                await addDoc(collection(db_fire, "contacts"), userData);
                message.success("Sent success.")
                setContactModalOpen(false)
                setLoading(false)
                setsubject("")
                setremark("")
            }}
                closeIcon={false}
                onCancel={_ => setContactModalOpen(false)}
                open={contactModalOpen}
                width={340}
                cancelText="Skip"
                okText="Submit">
                <Typography.Title level={5} align="center">Follow us for updates</Typography.Title>
                <Flex align='center' justify='space-around' style={{ margin: "15px 0" }}>
                    <Button style={{ fontSize: "16px" }} href="https://instagram.com/kamuska.in"><InstagramOutlined /></Button> &nbsp;
                    <Button style={{ fontSize: "16px" }} href="/"> <GlobalOutlined /> </Button>&nbsp;
                    <Button style={{ fontSize: "16px" }} href="https://github.com/kamuskafoods"> <GithubOutlined /> </Button> &nbsp;
                    <Button style={{ fontSize: "16px" }} href="https://x.com/kamuskafoods"> <XOutlined /> </Button>
                </Flex>
                <Typography.Text strong>Subject : </Typography.Text>
                <Input value={subject} onChange={e => setsubject(e.target.value)} placeholder='Type here subject' /> <br /> <br />
                <Typography.Text strong>Remark : </Typography.Text>
                <TextArea value={remark} onChange={e => setremark(e.target.value)} rows={3} placeholder='Remark - your query regarding coupon, for ad, account issues etc'>

                </TextArea> <br /><br />
            </Modal>
        </>
    )
}

export default Profile